module.exports = __webpack_public_path__ + "static/fonts/uni.75745d3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/uni.ttf
// module id = VwHn
// module chunks = 1